import { j as N } from "./jsx-runtime-3tyXYecC.mjs";
import { useEffect as G } from "react";
import { f } from "./index-LyFokDcn.mjs";
import { j as H, t as E } from "./theme-colors-uK40SfO5.mjs";
import { a as _ } from "./sizes-DktS74Qp.mjs";
import { s as U } from "./encore-sizes-Cg5eTN64.mjs";
import { c as a, j as Y, b as V, h as x } from "./encore-theme-Bgi7jWdM.mjs";
import { b as z, v as J, t as K, G as q, H as Z, e as Q, m as X } from "./tss-DN0acMKN.mjs";
import { f as L, a as $, t as u, b as h } from "./text-B5Opw2za.mjs";
import { B as ee } from "./Box-B5hjovXR.mjs";
import { f as te } from "./format-base-props-8NDUNDcL.mjs";
const F = {
  0: "0px",
  100: "4px",
  200: "8px",
  300: "12px",
  400: "16px",
  500: "20px",
  600: "24px",
  700: "32px",
  800: "48px",
  900: "64px",
  1e3: "1000px"
}, re = () => ({
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1200,
    xl: 1800
  },
  unit: "px",
  step: 5
}), ie = ({ palette: t, typography: i, breakpoints: n, spacing: s }) => {
  var e, o, r;
  return {
    MuiButton: {
      defaultProps: {
        variant: "contained",
        disableRipple: !0,
        disableElevation: !0
      },
      styleOverrides: {
        disableElevation: {
          boxShadow: "0 1px 0 0 rgba(0, 0, 0, 0.05)"
        },
        root: {
          minWidth: 0,
          textTransform: "none"
        },
        startIcon: {
          marginLeft: 0,
          marginRight: 8
        },
        endIcon: {
          marginLeft: 8,
          marginRight: 0
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
      },
      styleOverrides: {
        root: {
          fontFamily: "Lato",
          fontSize: i.fabricFontSize("medium")
        }
      }
    },
    MuiButtonGroup: {
      defaultProps: {
        variant: "contained",
        disableRipple: !0,
        disableElevation: !0
      },
      styleOverrides: {
        root: {
          "& .Mui-disabled": {
            "&, &:not(:last-of-type)": {
              borderColor: t.grey[300]
            }
          }
        }
      }
    },
    MuiCheckbox: {
      defaultProps: {
        disableRipple: !0
      },
      styleOverrides: {
        root: {
          backgroundColor: "unset",
          height: "auto",
          padding: 0
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: t.grey[300]
        },
        deleteIcon: {
          margin: s(0, 1, 0, 0)
        }
      }
    },
    MuiFormControl: {
      defaultProps: {
        variant: "outlined"
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          "&.Mui-disabled": {
            color: t.grey[500]
          }
        },
        root: {
          marginLeft: 0,
          marginRight: 0
        }
      }
    },
    MuiFormHelperText: {
      defaultProps: {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: "span"
      },
      styleOverrides: {
        root: {
          color: t.grey[700],
          fontSize: 13,
          lineHeight: "18px",
          marginLeft: 12
        }
      }
    },
    MuiIconButton: {
      defaultProps: {
        disableRipple: !0
      },
      styleOverrides: {
        root: {
          height: 34,
          borderRadius: 2,
          backgroundColor: t.primary.main,
          color: t.primary.contrastText,
          "&:hover": {
            backgroundColor: t.primary.lighter
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          maxWidth: "unset",
          overflow: "unset",
          color: (e = t.text) == null ? void 0 : e.secondary,
          "&.Mui-focused": {
            color: (o = t.text) == null ? void 0 : o.secondary
          }
        },
        outlined: {
          "&.MuiInputLabel-shrink": {
            transform: "translate(0px, 2px)"
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 2,
          color: (r = t.text) == null ? void 0 : r.primary
        },
        input: {
          padding: "8px 10px"
        }
      }
    },
    MuiRadio: {
      defaultProps: {
        disableRipple: !0
      },
      styleOverrides: {
        root: {
          backgroundColor: "unset",
          height: "auto",
          padding: 0
        }
      }
    },
    MuiTab: {
      defaultProps: {
        disableRipple: !0
      },
      styleOverrides: {
        root: {
          padding: 0,
          textTransform: "none",
          "&:hover": {
            color: t.primary.main,
            fill: t.primary.main
          },
          [n.up("sm")]: {
            minWidth: "unset",
            padding: 0
          }
        },
        textColorSecondary: {
          opacity: "unset",
          "&.Mui-selected": {
            color: t.primary.main,
            fill: t.primary.main,
            fontWeight: 700
          }
        },
        // Wrapper was removed https://github.com/mui/material-ui/pull/26926
        // wrapper: {
        // 	flexDirection: 'row',
        // 	margin: spacing(1.375, 2),
        // 	'& > svg': {
        // 		width: 21,
        // 		height: 21,
        // 	},
        // },
        labelIcon: {
          minHeight: "unset",
          paddingTop: "unset",
          "& .MuiTab-wrapper": {
            "& > svg": {
              width: 14,
              height: 14
            }
          },
          "& .MuiTab-wrapper > *:first-child": {
            marginBottom: "unset",
            marginRight: 8
          }
        }
      }
    },
    MuiTabs: {
      defaultProps: {
        textColor: "secondary",
        indicatorColor: "primary"
      },
      styleOverrides: {
        root: {
          color: t.grey[700],
          fill: t.grey[700]
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined"
      }
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: "h1",
          h2: "h2",
          h3: "h3",
          h4: "h4",
          h5: "h5"
        }
      },
      styleOverrides: {
        root: {
          color: t.grey[1e3]
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: "unset",
          height: "unset",
          flexShrink: "unset",
          fontSize: "unset",
          transition: "unset"
        }
      }
    }
  };
}, ne = () => ({
  MuiButton: {
    defaultProps: {
      variant: "contained",
      disableRipple: !0,
      disableElevation: !0
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiButtonGroup: {
    defaultProps: {
      variant: "contained",
      disableRipple: !0,
      disableElevation: !0
    }
  },
  MuiCheckbox: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiFormControl: {
    defaultProps: {
      variant: "outlined"
    }
  },
  MuiFormHelperText: {
    defaultProps: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      component: "span"
    }
  },
  MuiIconButton: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiRadio: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiTab: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiTabs: {
    defaultProps: {
      textColor: "secondary",
      indicatorColor: "primary"
    }
  },
  MuiTextField: {
    defaultProps: {
      variant: "outlined"
    }
  },
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        h1: "h1",
        h2: "h2",
        h3: "h3",
        h4: "h4",
        h5: "h5"
      }
    }
  }
}), oe = (t) => ({
  functional: {
    brandColor: a.brandColor,
    link: a.link
  },
  neutral: {
    0: a.white,
    50: a.gray05,
    100: a.gray1,
    200: a.gray2,
    300: a.gray3,
    400: a.gray4,
    500: a.gray5,
    600: a.gray6,
    700: a.gray7,
    800: a.gray8,
    900: a.gray9,
    1e3: a.gray10
  },
  primary: {
    100: (
      // @startCleanup PO_LOGO_SETTINGS_PAGE
      "lightest" in t ? t.lightest : (
        // @endCleanup PO_LOGO_SETTINGS_PAGE
        t[100]
      )
    ),
    500: (
      // @startCleanup PO_LOGO_SETTINGS_PAGE
      "lighter" in t ? t.lighter : (
        // @endCleanup PO_LOGO_SETTINGS_PAGE
        t[300]
      )
    ),
    900: (
      // @startCleanup PO_LOGO_SETTINGS_PAGE
      "base" in t ? t.base : (
        // @endCleanup PO_LOGO_SETTINGS_PAGE
        t[500]
      )
    ),
    1e3: (
      // @startCleanup PO_LOGO_SETTINGS_PAGE
      "dark" in t ? t.dark : (
        // @endCleanup PO_LOGO_SETTINGS_PAGE
        t[900]
      )
    )
  },
  sentiment: {
    success: {
      100: a.successLight,
      500: a.success,
      900: a.successDark
    },
    error: {
      100: a.errorLight,
      500: a.error,
      900: a.errorDark
    },
    warning: {
      100: a.warningLight,
      500: a.warning,
      900: a.warningDark
    },
    info: {
      100: a.infoLight,
      500: a.info,
      900: a.infoDark
    },
    discovery: {
      100: a.discoveryLight,
      500: a.discovery,
      900: a.discoveryDark
    },
    attention: {
      100: a.attentionLight,
      500: a.attention,
      900: a.attentionDark
    },
    notice: {
      900: a.noticeDark
    }
  }
});
function M({ borderRadiuses: t, primitives: i, spacing: n }) {
  const { functional: s, neutral: e, primary: o, sentiment: r } = i;
  return {
    text: {
      link: {
        idle: s.link,
        hover: o[900],
        muted: e[700],
        disabled: e[600]
      },
      neutral: {
        xWeak: e[500],
        weak: e[600],
        medium: e[700],
        strong: e[800],
        xStrong: e[900],
        inverted: e[0],
        forcedWhite: e[0]
      },
      primary: {
        strong: o[900]
      },
      error: {
        medium: r.error[500],
        strong: r.error[900]
      },
      warning: {
        medium: r.warning[500],
        strong: r.warning[900]
      },
      info: {
        medium: r.info[500],
        strong: r.info[900]
      },
      success: {
        medium: r.success[500],
        strong: r.success[900]
      },
      discovery: {
        medium: r.discovery[500],
        strong: r.discovery[900]
      }
    },
    icon: {
      bambooBrand: {
        medium: s.brandColor
      },
      link: {
        idle: s.link,
        hover: e[0],
        muted: e[0],
        disabled: e[0]
      },
      neutral: {
        xWeak: e[300],
        weak: e[400],
        medium: e[500],
        strong: e[600],
        xStrong: e[800],
        xxStrong: e[900],
        inverted: e[0]
      },
      notice: {
        strong: r.notice[900]
      },
      primary: {
        weak: o[100],
        medium: o[500],
        strong: o[900],
        xStrong: o[1e3]
      },
      error: {
        weak: r.error[100],
        medium: r.error[500],
        strong: r.error[900]
      },
      warning: {
        weak: r.warning[100],
        medium: r.warning[500],
        strong: r.warning[900]
      },
      info: {
        weak: r.info[100],
        medium: r.info[500],
        strong: r.info[900]
      },
      success: {
        weak: r.success[100],
        medium: r.success[500],
        strong: r.success[900]
      },
      discovery: {
        weak: r.discovery[100],
        medium: r.discovery[500],
        strong: r.discovery[900]
      },
      files: {
        doc: "#2076BB",
        esig: "#87328F",
        excel: "#3AA837",
        pdf: "#C32A2F",
        ppt: "#C26C1A"
      }
    },
    border: {
      neutral: {
        xxWeak: e[100],
        xWeak: e[200],
        weak: e[300],
        medium: e[400],
        strong: e[500],
        xStrong: e[700],
        inverted: e[0],
        forcedWhite: e[0]
      },
      primary: {
        weak: o[100],
        medium: o[500],
        strong: o[900],
        xStrong: o[1e3]
      },
      error: {
        weak: r.error[100],
        medium: r.error[500],
        strong: r.error[900]
      },
      warning: {
        weak: r.warning[100],
        medium: r.warning[500],
        strong: r.warning[900]
      },
      info: {
        weak: r.info[100],
        medium: r.info[500],
        strong: r.info[900]
      },
      success: {
        weak: r.success[100],
        medium: r.success[500],
        strong: r.success[900]
      },
      discovery: {
        weak: r.discovery[100],
        medium: r.discovery[500],
        strong: r.discovery[900]
      }
    },
    surface: {
      neutral: {
        xxWeak: e[50],
        xWeak: e[100],
        weak: e[200],
        medium: e[400],
        strong: e[600],
        xStrong: e[800],
        xxStrong: e[900],
        inverted: e[0],
        forcedWhite: e[0]
      },
      primary: {
        weak: o[100],
        medium: o[500],
        strong: o[900],
        xStrong: o[1e3]
      },
      notice: {
        strong: r.notice[900]
      },
      error: {
        weak: r.error[100],
        medium: r.error[500],
        strong: r.error[900]
      },
      warning: {
        weak: r.warning[100],
        medium: r.warning[500],
        strong: r.warning[900]
      },
      info: {
        weak: r.info[100],
        medium: r.info[500],
        strong: r.info[900]
      },
      success: {
        weak: r.success[100],
        medium: r.success[500],
        strong: r.success[900]
      },
      discovery: {
        weak: r.discovery[100],
        medium: r.discovery[500],
        strong: r.discovery[900]
      }
    },
    radius: {
      none: "0",
      xxxSmall: t[100],
      xxSmall: t[200],
      xSmall: t[300],
      small: t[400],
      medium: t[500],
      large: t[600],
      xLarge: t[700],
      xxLarge: t[800],
      xxxLarge: t[900],
      full: t[1e3]
    },
    space: {
      none: n(0),
      xxxs: n(0.25),
      xxs: n(0.5),
      xs: n(1),
      s: n(1.5),
      m: n(2),
      l: n(2.5),
      xl: n(3),
      xxl: n(4),
      xxxl: n(5)
    }
  };
}
function se({ borderRadiuses: t, primitives: i, spacing: n }) {
  const { functional: s, neutral: e, primary: o, sentiment: r } = i;
  return {
    text: {
      link: {
        idle: s.link,
        hover: e[0],
        muted: e[0],
        disabled: e[0]
      },
      neutral: {
        xWeak: e[300],
        weak: e[300],
        medium: e[300],
        strong: e[100],
        xStrong: e[50],
        inverted: e[900],
        forcedWhite: e[0]
      },
      primary: {
        strong: o[900]
      },
      error: {
        medium: r.error[500],
        strong: r.error[900]
      },
      warning: {
        medium: r.warning[500],
        strong: r.warning[900]
      },
      info: {
        medium: r.info[500],
        strong: r.info[900]
      },
      success: {
        medium: r.success[500],
        strong: r.success[900]
      },
      discovery: {
        medium: r.discovery[500],
        strong: r.discovery[900]
      }
    },
    icon: {
      bambooBrand: {
        medium: s.brandColor
      },
      link: {
        idle: s.link,
        hover: e[0],
        muted: e[0],
        disabled: e[0]
      },
      neutral: {
        xWeak: e[600],
        weak: e[500],
        medium: e[400],
        strong: e[300],
        xStrong: e[50],
        xxStrong: e[50],
        inverted: e[900]
      },
      notice: {
        strong: r.notice[900]
      },
      primary: {
        weak: o[100],
        medium: o[500],
        strong: o[900],
        xStrong: o[1e3]
      },
      error: {
        weak: r.error[100],
        medium: r.error[500],
        strong: r.error[900]
      },
      warning: {
        weak: r.warning[100],
        medium: r.warning[500],
        strong: r.warning[900]
      },
      info: {
        weak: r.info[100],
        medium: r.info[500],
        strong: r.info[900]
      },
      success: {
        weak: r.success[100],
        medium: r.success[500],
        strong: r.success[900]
      },
      discovery: {
        weak: r.discovery[100],
        medium: r.discovery[500],
        strong: r.discovery[900]
      },
      files: {
        doc: "#2076BB",
        esig: "#87328F",
        excel: "#3AA837",
        pdf: "#C32A2F",
        ppt: "#C26C1A"
      }
    },
    border: {
      neutral: {
        xxWeak: e[700],
        xWeak: e[700],
        weak: e[600],
        medium: e[600],
        strong: e[400],
        xStrong: e[200],
        inverted: e[700],
        forcedWhite: e[700]
      },
      primary: {
        weak: o[100],
        medium: o[500],
        strong: o[900],
        xStrong: o[1e3]
      },
      error: {
        weak: r.error[100],
        medium: r.error[500],
        strong: r.error[900]
      },
      warning: {
        weak: r.warning[100],
        medium: r.warning[500],
        strong: r.warning[900]
      },
      info: {
        weak: r.info[100],
        medium: r.info[500],
        strong: r.info[900]
      },
      success: {
        weak: r.success[100],
        medium: r.success[500],
        strong: r.success[900]
      },
      discovery: {
        weak: r.discovery[100],
        medium: r.discovery[500],
        strong: r.discovery[900]
      }
    },
    surface: {
      neutral: {
        xxWeak: e[800],
        xWeak: e[700],
        weak: e[700],
        medium: e[500],
        strong: e[300],
        xStrong: e[50],
        xxStrong: e[50],
        inverted: e[900],
        forcedWhite: e[900]
      },
      primary: {
        weak: o[100],
        medium: o[500],
        strong: o[900],
        xStrong: o[1e3]
      },
      notice: {
        strong: r.notice[900]
      },
      error: {
        weak: r.error[100],
        medium: r.error[500],
        strong: r.error[900]
      },
      warning: {
        weak: r.warning[100],
        medium: r.warning[500],
        strong: r.warning[900]
      },
      info: {
        weak: r.info[100],
        medium: r.info[500],
        strong: r.info[900]
      },
      success: {
        weak: r.success[100],
        medium: r.success[500],
        strong: r.success[900]
      },
      discovery: {
        weak: r.discovery[100],
        medium: r.discovery[500],
        strong: r.discovery[900]
      }
    },
    radius: {
      none: "0",
      xxxSmall: t[100],
      xxSmall: t[200],
      xSmall: t[300],
      small: t[400],
      medium: t[500],
      large: t[600],
      xLarge: t[700],
      xxLarge: t[800],
      xxxLarge: t[900],
      full: t[1e3]
    },
    space: {
      none: n(0),
      xxxs: n(0.25),
      xxs: n(0.5),
      xs: n(1),
      s: n(1.5),
      m: n(2),
      l: n(2.5),
      xl: n(3),
      xxl: n(4),
      xxxl: n(5)
    }
  };
}
function ae({ borderRadiuses: t, brandColors: i, paletteMode: n, spacing: s }) {
  const e = oe(i);
  switch (n) {
    case "light":
      return M({ borderRadiuses: t, primitives: e, spacing: s });
    case "dark":
      return se({ borderRadiuses: t, primitives: e, spacing: s });
    default:
      return M({ borderRadiuses: t, primitives: e, spacing: s });
  }
}
function le(t, i = "90deg") {
  return `linear-gradient(${i}, ${t.lighter} 0, ${t.lightest} 100%)`;
}
function ce() {
  return {
    lighterToLightestLinear: le
  };
}
const ge = {
  min: 1124,
  max: 1348,
  base: "100%",
  buffer: 32
}, me = {
  padding: 32,
  paddingY: 24
}, de = {
  min: 1124,
  max: 1600,
  base: "100%",
  buffer: 16
}, ue = () => f.ifFeature(
  "encore",
  {
    pageCapsule: me,
    pageWidths: de
  },
  {
    pageCapsule: { padding: 0, paddingY: 0 },
    pageWidths: ge
  }
), P = {
  100: {
    opacity: 0.04,
    lengths: "1px 1px 0px 1px"
  },
  300: {
    opacity: 0.03,
    lengths: "1px 1px 0px 2px"
  },
  500: {
    opacity: 0.05,
    lengths: "2px 2px 0px 2px"
  },
  700: {
    opacity: 0.1,
    lengths: "3px 3px 10px 2px"
  }
};
function v(t, i, n = f.ifFeature("encore", i.gray[900], i.gray[800])) {
  switch (t) {
    case "default":
      return i.primary.main;
    case "error":
      return i.error.main;
    case "info":
      return i.info.main;
    case "warning":
      return i.warning.main;
    default:
      return n;
  }
}
const b = (t, i) => `${P[t].lengths} ${z(i, P[t].opacity)}`, B = (t, i) => `${t}px solid ${i}`, he = {
  background: "none",
  border: "none",
  cursor: "pointer",
  textDecoration: "none",
  "-moz-appearance": "none",
  "-webkit-appearance": "none"
};
function fe(t) {
  return {
    border: `1px solid ${t.lighter}`,
    boxShadow: `0 0 0 2px ${z(t.lightest, 0.35)}`,
    outline: 0
  };
}
function ye(t) {
  const i = t.match(/[A-Za-z0-9]{2}/g);
  return i ? i.map((n) => parseInt(n, 16)).join() : "";
}
function pe(t, { fill: i }) {
  const n = t.replace(/fill="#0{3}(?:0{3})?"/g, `fill="${i}"`);
  return `url("data:image/svg+xml;base64,${window.btoa(n)}")`;
}
const xe = ({ palette: t }, i) => {
  const { disabled: n, status: s, viewMode: e, focused: o = !1, hover: r = !1 } = i, y = "500", w = "100", p = 0.5;
  if (n)
    return {
      border: `1px solid ${t.gray[400]}`
    };
  if (s) {
    const g = v(s, t);
    return o ? {
      border: `1px solid ${g}`,
      boxShadow: `${b(y, g)}, 0 0 0 ${p}px ${g}`
    } : {
      border: `1px solid ${g}`,
      boxShadow: `${b(w, v(s, t))}`
    };
  }
  if (o) {
    const g = t.primary.lighter;
    return {
      border: `1px solid ${g}`,
      boxShadow: `${b(y, g)}, 0 0 0 ${p}px ${g}`
    };
  }
  return e ? {
    border: `1px solid ${r ? t.gray[300] : t.gray[200]}`
  } : {
    border: `1px solid ${t.gray[400]}`,
    boxShadow: `${b(w, t.gray[900])}`
  };
};
function we(t) {
  return {
    border: B(1, t.gray[600]),
    boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.15)"
  };
}
const l = (t) => `${t}px`;
function be() {
  return {
    alpha: z,
    border: B,
    boxShadow: b,
    buttonReset: he,
    darken: J,
    fieldStatusColor: v,
    focusRing: fe,
    hexToRgb: ye,
    inlineSvg: pe,
    inputOutline: xe,
    lighten: K,
    popoverSurface: we
  };
}
const D = () => {
  const t = [
    "#759e00",
    "#e8454d",
    "#f96422",
    "#6f90e8",
    "#d05489",
    "#3aa837",
    "#b88f00",
    "#0fa698",
    "#9a6dc8",
    "#1b8ab4",
    "#6a6a6a"
  ], i = [
    "#7E9D2E",
    "#D65253",
    "#E76E38",
    "#768FE2",
    "#C15C88",
    "#5BA647",
    "#B2912F",
    "#4CA498",
    "#936FC2",
    "#4288B0"
  ];
  return f.ifFeature("encore", i, t);
}, ke = (t) => {
  const i = typeof t == "object", { themeColors: n } = H, s = n.find((r) => r.name === t) || n[0], { colors: e } = Y, o = {
    50: e.gray05,
    100: e.gray1,
    200: e.gray2,
    300: e.gray3,
    400: e.gray4,
    500: e.gray5,
    600: e.gray6,
    700: e.gray7,
    800: e.gray8,
    900: e.gray9,
    1e3: e.gray10
  };
  return {
    action: {
      active: e.info,
      highlight: e.action
    },
    background: {
      default: e.white,
      paper: e.gray1
    },
    charts: D(),
    common: {
      black: "#000",
      white: "#FFF"
    },
    discovery: {
      contrastText: e.white,
      dark: e.discoveryDark,
      light: e.discoveryLight,
      main: e.discovery
    },
    error: {
      contrastText: e.white,
      dark: e.errorDark,
      light: e.errorLight,
      main: e.error
    },
    gray: o,
    grey: o,
    info: {
      contrastText: e.white,
      dark: e.infoDark,
      light: e.infoLight,
      main: e.info
    },
    link: {
      main: e.link
    },
    mode: "light",
    primary: (
      // @startCleanup PO_LOGO_SETTINGS_PAGE
      i ? (
        // @endCleanup PO_LOGO_SETTINGS_PAGE
        {
          contrastText: e.white,
          dark: t[900],
          light: t[300],
          /**
           * There is no `lighter` color, so we're using the
           * `light` color for backwards compatibility.
           */
          lighter: t[300],
          lightest: t[100],
          main: t[500]
        }
      ) : {
        contrastText: e.white,
        dark: s.dark,
        light: s.light,
        /**
         * There is no `lighter` color, so we're using the
         * `light` color for backwards compatibility.
         */
        lighter: s.light,
        lightest: s.lightest,
        main: s.base
      }
    ),
    secondary: {
      contrastText: e.gray8,
      dark: e.gray6,
      light: e.gray3,
      main: e.gray2
    },
    success: {
      contrastText: e.white,
      dark: e.successDark,
      light: e.successLight,
      main: e.success
    },
    text: {
      primary: e.gray9,
      secondary: e.gray8
    },
    warning: {
      contrastText: e.white,
      dark: e.warningDark,
      light: e.warningLight,
      main: e.warning
    }
  };
}, ve = (t) => {
  const i = typeof t == "object", { themeColors: n } = E, s = n.find((r) => r.name === t) || n[0], { colors: e } = V, o = {
    // 50 gives Encore palette better backwards-compatibility
    50: e.gray1,
    100: e.gray1,
    200: e.gray2,
    300: e.gray3,
    400: e.gray4,
    500: e.gray5,
    600: e.gray6,
    700: e.gray7,
    800: e.gray8,
    900: e.gray9,
    1e3: e.gray10
  };
  return {
    mode: "light",
    primary: (
      // @startCleanup PO_LOGO_SETTINGS_PAGE
      i ? (
        // @endCleanup PO_LOGO_SETTINGS_PAGE
        {
          main: t[500],
          /*
           * We do not support `primary.dark`, but MUI uses it under the hood in some of our
           * components, so it should still match our brand colors.
           */
          dark: t[100],
          light: t[300],
          lighter: t[100],
          lightest: t[100],
          contrastText: e.white
        }
      ) : {
        main: s.base,
        /*
         * We do not support `primary.dark`, but MUI uses it under the hood in some of our
         * components, so it should still match our brand colors.
         */
        dark: s.light,
        light: s.light,
        lighter: s.lighter,
        lightest: s.lightest,
        contrastText: e.white
      }
    ),
    secondary: {
      main: e.gray2,
      dark: e.gray6,
      light: e.gray3,
      contrastText: e.gray8
    },
    action: {
      active: e.info,
      highlight: e.action
    },
    background: {
      default: e.white,
      paper: e.gray1
    },
    text: {
      primary: e.gray10,
      secondary: e.gray8
    },
    error: {
      main: e.danger,
      dark: e.dangerDark,
      light: e.dangerLight,
      contrastText: e.white
    },
    warning: {
      main: e.attention,
      dark: e.attentionDark,
      light: e.attentionLight,
      contrastText: e.white
    },
    success: {
      main: e.success,
      dark: e.successDark,
      light: e.successLight,
      contrastText: e.white
    },
    info: {
      main: e.info,
      dark: e.infoDark,
      light: e.infoLight,
      contrastText: e.white
    },
    common: {
      black: "#000",
      white: "#FFF"
    },
    charts: D(),
    grey: o,
    gray: o,
    // below props are only used in Encore but are required to satisfy the Palette type def
    discovery: {},
    link: {}
  };
}, Se = (t) => {
  const i = t.gray;
  return {
    fabricFontSize: L,
    fabricLineHeight: $,
    fontFamily: "Lato, sans-serif",
    fontSize: 15,
    fontWeightLight: 300,
    fontWeightRegular: u.regular,
    fontWeightMedium: u.medium,
    fontWeightSemibold: u.semibold,
    fontWeightBold: u.bold,
    fontWeightHeavy: u.heavy,
    h1: {
      fontSize: "2.266rem",
      // 34px
      fontWeight: u.bold,
      lineHeight: "2.8rem",
      // 42px
      margin: "1.066rem 0"
      // 16px
    },
    h2: {
      fontSize: "1.866rem",
      // 28px
      fontWeight: u.bold,
      lineHeight: "2.4rem",
      // 36px
      margin: "0.733rem 0"
      // 11px
    },
    h3: {
      fontSize: "1.466rem",
      // 22px
      fontWeight: u.semibold,
      lineHeight: "2rem",
      // 30px
      margin: "0.866rem 0"
      // 13px
    },
    h4: {
      fontSize: "1.2rem",
      // 18px
      fontWeight: u.semibold,
      lineHeight: "1.733rem",
      // 26px
      margin: "0.733rem 0"
      // 11px
    },
    h5: {
      fontSize: "1.066rem",
      // 16px
      fontWeight: u.semibold,
      lineHeight: "1.467rem",
      // 22px
      margin: "0.6rem 0"
      // 9px
    },
    h6: {
      fontSize: "1.066rem",
      // 16px
      fontWeight: u.semibold,
      lineHeight: "1.467rem",
      // 22px
      margin: "0.6rem 0"
      // 9px
    },
    body1: {
      fontSize: "1rem",
      // 15px
      lineHeight: "1.467rem"
      // 22px
    },
    body2: {
      fontSize: "0.933rem",
      // 14px: bodySmall
      lineHeight: "1.333rem"
      // 20px: bodySmall
    },
    caption: {
      color: i[600]
    },
    biggie: {
      fontSize: h.biggie.size,
      lineHeight: l(h.biggie.line)
    },
    large: {
      fontSize: h.large.size,
      lineHeight: l(h.large.line)
    },
    medium: {
      fontSize: h.medium.size,
      lineHeight: l(h.medium.line)
    },
    small: {
      fontSize: h.small.size,
      lineHeight: l(h.small.line)
    },
    teenie: {
      fontSize: h.teenie.size,
      lineHeight: l(h.teenie.line)
    }
  };
}, ze = (t) => Se(t), c = {
  biggie: {
    size: 16,
    line: 24
  },
  large: {
    size: 16,
    line: 24
  },
  medium: {
    size: 15,
    line: 22
  },
  small: {
    size: 14,
    line: 20
  },
  teenie: {
    size: 13,
    line: 19
  },
  xsmall: {
    size: 13,
    line: 19
  }
}, m = {
  h1: {
    size: 42,
    line: 52
  },
  h2: {
    size: 32,
    line: 38
  },
  h3: {
    size: 24,
    line: 30
  },
  h4: {
    size: 21,
    line: 26
  },
  h5: {
    size: 18,
    line: 24
  },
  h6: {
    size: 18,
    line: 24
  }
}, d = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  heavy: 700
}, Te = (t) => {
  const i = t.gray, n = "Inter, sans-serif", s = "Fields, serif";
  return {
    fabricFontSize: L,
    fabricLineHeight: $,
    fontFamily: n,
    fontSize: c.medium.size,
    fontWeightLight: d.regular,
    fontWeightRegular: d.regular,
    fontWeightMedium: d.medium,
    fontWeightSemibold: d.semibold,
    fontWeightBold: d.bold,
    fontWeightHeavy: d.bold,
    h1: {
      fontFamily: s,
      fontSize: m.h1.size,
      fontWeight: d.bold,
      lineHeight: l(m.h1.line),
      margin: "0"
    },
    h2: {
      fontFamily: s,
      fontSize: m.h2.size,
      fontWeight: d.semibold,
      lineHeight: l(m.h2.line),
      margin: "0"
    },
    h3: {
      fontFamily: s,
      fontSize: m.h3.size,
      fontWeight: d.semibold,
      lineHeight: l(m.h3.line),
      margin: "0"
    },
    h4: {
      fontFamily: s,
      fontSize: m.h4.size,
      fontWeight: d.semibold,
      lineHeight: l(m.h4.line),
      margin: "0"
    },
    h5: {
      fontSize: m.h5.size,
      fontWeight: d.semibold,
      lineHeight: l(m.h5.line),
      margin: "0"
    },
    h6: {
      fontSize: m.h5.size,
      fontWeight: d.semibold,
      lineHeight: l(m.h5.line),
      margin: "0"
    },
    body1: {
      fontSize: c.medium.size,
      lineHeight: l(c.medium.line)
    },
    body2: {
      fontSize: c.small.size,
      lineHeight: l(c.small.line)
    },
    caption: {
      color: i[500]
    },
    biggie: {
      fontSize: c.large.size,
      lineHeight: l(c.large.line)
    },
    large: {
      fontSize: c.large.size,
      lineHeight: l(c.large.line)
    },
    medium: {
      fontSize: c.medium.size,
      lineHeight: l(c.medium.line)
    },
    small: {
      fontSize: c.small.size,
      lineHeight: l(c.small.line)
    },
    xsmall: {
      fontSize: c.xsmall.size,
      lineHeight: l(c.xsmall.line)
    },
    teenie: {
      fontSize: c.xsmall.size,
      lineHeight: l(c.xsmall.line)
    }
  };
}, O = { 100: "#F1FCED", 300: "#97ED7E", 500: "#287411", 900: "#18470A" };
let C = O;
function Ye(t) {
  C = t, window.dispatchEvent(new CustomEvent("fabric:set-theme-color", { detail: t })), Object.entries(t).forEach(([i, n]) => {
    document.body.style.setProperty(`--fab-theme-color-${i}`, n);
  }), document.body.style.setProperty("--fab-theme-color-lightest10", x(t[100], "0.1")), document.body.style.setProperty("--fab-theme-color-lightest35", x(t[100], "0.35")), document.body.style.setProperty("--fab-theme-color-lightest50", x(t[100], "0.5")), document.body.style.setProperty("--fabric-theme-dark", t[900]), document.body.style.setProperty("--fabric-theme-base", t[500]), document.body.style.setProperty("--fabric-theme-light", t[300]), document.body.style.setProperty("--fabric-theme-lighter", t[300]), document.body.style.setProperty("--fabric-theme-lightest", t[100]), document.body.style.setProperty("--fabric-theme-lightest10", x(t[100], "0.1")), document.body.style.setProperty("--fabric-theme-lightest35", x(t[100], "0.35")), document.body.style.setProperty("--fabric-theme-lightest50", x(t[100], "0.5"));
}
function Ve() {
  return C;
}
const We = (t = O, i, n) => {
  const s = re(), e = ce(), o = ue(), r = be(), y = {}, p = { ...f.ifFeature("encore", ke, ve)(t), ...y }, { themeColors: g } = f.ifFeature("encore", H, E), T = q(f.ifFeature("encore", U.root, _.root)), j = ae({
    borderRadiuses: F,
    // @ts-expect-error selectedColors for jade does not have a dark variant so this throws a type error.
    brandColors: (
      // @startCleanup PO_LOGO_SETTINGS_PAGE
      typeof t == "object" ? (
        // @endCleanup PO_LOGO_SETTINGS_PAGE
        t
      ) : g.find((I) => I.name === t) || g[0]
    ),
    paletteMode: f.ifFeature("encore", "light", "dark"),
    spacing: T
  }), W = f.ifFeature("encore", Te, ze)(p), A = f.ifFeature(
    "encore",
    ne,
    () => ie({
      breakpoints: Z(s),
      palette: p,
      spacing: T,
      typography: W
    })
  )();
  return Q({
    breakpoints: s,
    components: A,
    layout: o,
    mixins: r,
    palette: p,
    typography: W
  }, { borderRadiuses: F, constructs: j, gradients: e, mode: i, themeName: n });
}, Fe = [
  "animation",
  "background",
  "border",
  "box-shadow",
  "boxShadow",
  "caret-color",
  "caretColor",
  "@charset",
  "color",
  "font",
  "@font-face",
  "@import",
  "@keyframes",
  "outline",
  "transition",
  "text-decoration",
  "textDecoration"
], Me = ["font-size", "fontSize"];
let k;
const S = (t, i) => {
  const n = i ? `. ${i}` : "";
  if (window.ENV !== "prod")
    throw new Error(`Invalid key: ${t}${n}`);
}, Pe = (t, i) => {
  !t.includes("@media") && !t.includes("@container") && S(t, "Nested selectors dissallowed. Only @media and @container pseudo-selectors are valid."), t.includes("@media") && (t.includes("all") || t.includes("screen")) && S(t, "Due to the potential for abuse, 'all' and 'screen' are disallowed on @media queries."), t !== "@media print" && R(i);
}, He = (t, i) => {
  const s = `^(${Fe.join("|")}).*$`;
  !t.match(s) || i === "TYPOGRAPHY" && Me.includes(t) || S(t, "Only layout CSS properties are allowed.");
}, Ee = ([t, i], n) => {
  if (typeof i == "object") {
    Pe(t, i);
    return;
  }
  He(t, n);
}, R = (t, i) => Object.entries(t).forEach((n) => Ee(n, i)), Le = (t, i) => {
  k = k || We("lime4");
  const n = typeof t == "function" ? t(k) : t;
  R(n, i);
}, $e = X()((t, { getStyles: i }) => ({
  root: typeof i == "function" ? i(t) : i
  // coerce to CSSObject which is more inclusive than ours
}));
function Je(t) {
  const {
    children: i,
    getStyles: n,
    containerRef: s,
    reason: e,
    component: o = "div",
    unsupportedCSSFeature: r,
    ...y
  } = t, { classes: w } = $e({ getStyles: n });
  return G(() => {
    Le(n, e);
  }, [n, e]), /* @__PURE__ */ N.jsx(
    ee,
    {
      className: w.root,
      component: o,
      "data-fabric-component": "LayoutEscapeHatch",
      ref: s,
      ...te(y),
      children: i
    }
  );
}
const Ke = (t) => t, qe = (t) => t;
export {
  O as D,
  Je as L,
  We as a,
  qe as c,
  Ve as g,
  Ke as m,
  Ye as s
};
//# sourceMappingURL=layout-escape-hatch-helper-B6LKm1c_.mjs.map
